module.exports = __webpack_public_path__ + "images/ssangyongead0bf3e29093390434c9eb1df6a2d94.png";